import { createContext } from 'react';
import uuid from 'uuid/v4';

export const AuditSearchContext = createContext<string>(uuid());
